import { getConfiguration } from '@chr/common-web-ui-configuration';
import { getAxiosInstance } from '@chr/online-shared-microsite-core';
import { AxiosInstance, AxiosRequestConfig } from 'axios';

type AuthToken = string | undefined;

export type AxiosRequestFn<T> = (
  url: string,
  config?: AxiosRequestConfig<unknown>,
  authToken?: AuthToken,
) => Promise<T>;

export type Client = {
  axios: AxiosInstance;
  gatewayApiUri: string;
  authToken?: string;
};

export const getClient = async (): Promise<Client> => {
  const [axios, { gatewayApiUri }, authToken] = await Promise.all([
    getAxiosInstance(),
    getConfiguration<AppConfig>(),
    getAuthToken(),
  ]);

  return { axios, gatewayApiUri, authToken };
};

export const getAuthToken = async () => {
  const data = localStorage.getItem('Online.auth.data');
  const token = JSON.parse(data ?? '{}').accessToken as AuthToken;

  return Promise.resolve(token);
}